import React from 'react';
import baseImageSrc from '../../../assets/images/svgs/base.svg';

const BackgroundBase = () => {
	return <img id={'base'} src={baseImageSrc} alt="base of the doc"/>;
};

export { BackgroundBase };
